import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Constants } from 'src/app/config/constant';
import { CookieService } from 'src/app/services/cookie.service';

@Component({
  standalone: true,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  imports: [
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    FormsModule,
    CommonModule,
  ],
})
export class LoginComponent implements OnInit {
  showPassword: boolean = false;

  buttonClicked = false;

  ssoLogin: boolean = false;

  emailerror: boolean = true;

  login = {
    userID: '',
    pwd: '',
  };

  sso = {
    email: '',
  };

  image: string = 'url("../../../assets/bg.webp")';

  constructor(
    private authService: AuthService,
    private router: Router,
    // private route: ActivatedRoute,
    private snackbar: MatSnackBar,
    private _const: Constants,
    private mixpanel: MixpanelService,
    private cookie: CookieService
  ) {}

  ngOnInit(): void {
    // ? for query
    // this.route.queryParams.subscribe(params => {
    //   const token = params['token'];
    //   if (token) {
    //     sessionStorage.setItem('access', token);
    //     sessionStorage.setItem('isUserLoggedIn', 'true')
    //   }
    // });
    // ? for cookie
    let accessToken = this.cookie.getCookieValue('Authorization');
    if (accessToken) {
      sessionStorage.setItem('access', accessToken);
      sessionStorage.setItem('isUserLoggedIn', 'true');
      this.cookie.deleteCookie('Authorization', '.bigyellowfish.io', '/');
    }
    this.mixpanel.track('page_view', {
      page: 'Login',
      category: 'Auth',
      button: '-',
    });
    let val: string | null = sessionStorage.getItem('isUserLoggedIn');
    if (val != null && val == 'true') {
      this.router.navigate(['dashboard']);
    }
  }

  onSubmit(loginForm: { value: any }) {
    this.mixpanel.identify(loginForm.value.userID);
    this.mixpanel.track('button_click', {
      page: 'Login',
      category: 'Auth',
      button: 'Login',
    });
    this.buttonClicked = true;
    this.authService
      .login(loginForm.value.userID, loginForm.value.pwd)
      .subscribe(
        (data) => {
          if (data.status) {
            if (data.data.access) {
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'success',
              });
              this.router.navigate(['/dashboard']);
            }
          } else {
            this.snackbar.open(data.message, undefined, {
              duration: 5000,
              panelClass: 'failure',
            });
            this.buttonClicked = false;
          }
        },
        (error) => {
          this.buttonClicked = false;
        }
      );
  }

  validateEmailList(control: { value: string }) {
    if (control.value && control.value.trim() !== '') {
      const emailRegex =
        /^\s*([\w+-.%]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\s*(,\s*([\w+-.%]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\s*)*$/;
      if (emailRegex.test(control.value)) {
        this.emailerror = true;
      } else {
        this.emailerror = false;
      }
    }
  }

  onSSO(ssoForm: { value: any }) {
    window.location.href = `${this._const.API}/sso/auth`;
    // this.authService
    //   .ssoLogin()
    //   .subscribe(
    //     (data) => {
    //       if (data) {
    //         console.log(data);
    //         this.snackbar.open(data.message, undefined, {
    //           duration: 5000,
    //           panelClass: 'success',
    //         });
    //         this.router.navigate(['/dashboard']);
    //       } else {
    //         this.snackbar.open(data.message, undefined, {
    //           duration: 5000,
    //           panelClass: 'failure',
    //         });
    //         this.buttonClicked = false;
    //       }
    //     },
    //     (error) => {
    //       this.buttonClicked = false;
    //     }
    //   );
  }

  onSSOdemo(ssoForm: { value: any }) {
    this.buttonClicked = true;
    this.authService.ssoDemo(ssoForm.value.email).subscribe(
      (data) => {
        if (data) {
          window.location.href = data.samlRequestURL;
        } else {
          this.buttonClicked = false;
        }
      },
      (error) => {
        this.buttonClicked = false;
      }
    );
  }
}
